import http from '@/utils/ajax'
import { ADMINMEMBER_INIT_LOADING, ADMINMEMBER_INIT_SUCCESS, ADMINMEMBER_INIT_FAIL, TABMENU, MISCTAB, TRANSLINK } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  member: {
    trans: {
      quoteInfo: {
        id: null,
        product: null,
        plan: null,
        paid: null,
        premiumPaid: null,
        appAdd1: null,
        appAdd2: null,
        appAdd3: null,
        appAdd4: null,
        appDob: null,
        appEmail: null,
        appGender: null,
        appJointApplicant: null,
        appMobileNo: null,
        appName: null,
        appNricPassport: null,
        appOccupation: null,
        appPostalCode: null,
        appSalutation: null,
        appTelNo1: null,
        appTelNo2: null,
        constrnCls: null,
        mailAdd: null,
        mailAdd1: null,
        mailAdd2: null,
        mailAdd3: null,
        mailAdd4: null,
        mailPostalCode: null,
        occupancy: null,
        riskAdd1: null,
        riskAdd2: null,
        riskAdd3: null,
        riskAdd4: null,
        fwTransNo: null
      },
      insuredInfo: {
        appId: null,
        duration: null,
        endDate: null,
        optCvrs: null,
        paid: null,
        plan: null,
        polWordingUrl: null,
        premium: null,
        product: null,
        productBrochureUrl: null,
        proposalNo: null,
        proposalRefNo: null,
        startDate: null
      }
    },
    tabMenu: {
      tab: 0,
      displayReviewTab: false
    },
    tabMiscMenu: {
      display: false,
      text: ''
    }
  }
}

const getters = {

}

const mutations = {
  [ADMINMEMBER_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [ADMINMEMBER_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [ADMINMEMBER_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [TABMENU](state, data) {
    state.member.tabMenu.tab = data.tabMenu
    state.member.tabMenu.displayReviewTab = data.displayReviewTab
  },
  [MISCTAB](state, data) {
    state.member.tabMiscMenu.display = data.misc
    state.member.tabMiscMenu.text = data.miscText
  },
  [TRANSLINK](state, link) {
    state.member.trans = link
  }
}

const actions = {
  async memberManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.memberManagement
    commit(ADMINMEMBER_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(ADMINMEMBER_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(ADMINMEMBER_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
